import { useState } from "react";

import Button from "components/Button";
import HollowButton from "components/HollowButton";

import styles from "./styles.module.scss";

interface Props {
  title: string;
  label: string;
  /** Zwrot i odrzucenie bez uzasadnienia zostawiają autora bez informacji, co poprawić. */
  required?: boolean;
  loading?: boolean;
  onClose: () => void;
  onApply: (comment: string) => void;
}

// Krótkie okno na komentarz towarzyszący czynności obiegu — odpowiednik modali
// Return / Sign z Kwantum.SL.LocalLaw.

const CommentModal = ({
  title,
  label,
  required = false,
  loading = false,
  onClose,
  onApply,
}: Props) => {
  const [comment, setComment] = useState("");

  const canApply = !required || !!comment.trim();

  return (
    <div className={styles.overlay} onMouseDown={onClose}>
      <div className={styles.modal} onMouseDown={(e) => e.stopPropagation()}>
        <div className={styles.modalTitle}>{title}</div>

        <div className={styles.modalBody}>
          <div className={styles.field}>
            <label className={styles.fieldLabel}>{label}</label>
            <textarea
              className={styles.textArea}
              value={comment}
              autoFocus
              onChange={(e) => setComment(e.target.value)}
            />
            {required && !canApply && (
              <span className={styles.fieldError}>Komentarz jest wymagany.</span>
            )}
          </div>
        </div>

        <div className={styles.modalFooter}>
          <HollowButton text="Anuluj" onClick={onClose} />
          <Button
            text="Zatwierdź"
            loading={loading}
            disabled={!canApply}
            onClick={() => canApply && onApply(comment.trim())}
          />
        </div>
      </div>
    </div>
  );
};

export default CommentModal;
